<script lang="ts" setup></script>

<template>
  <v-app class="app pa-6 d-flex">
    <v-progress-circular
      class="app__loading-spinner page-centered"
      indeterminate
      size="100"
      width="7"
      color="primary"
    />
  </v-app>
</template>

<style lang="scss" scoped>
.app {
  height: 100vh;
  max-height: 100vh;
}
</style>
